module.exports = __webpack_public_path__ + "img/tutorial_query-type.48c3cc61.png";